// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"945":"dashboard","6140":"business-volume","6738":"createApp-42f9d7e6","7205":"cession","8253":"tpl","9884":"admin"}[chunkId] + "." + {"945":"90629701","6140":"f352050a","6738":"4c0f13b2","7205":"f0b386d0","8253":"173c130a","9884":"b0f3e534"}[chunkId] + ".css";
};